import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, EventEmitter, Directive, Inject, HostBinding, Output, HostListener, NgModule } from '@angular/core';
import * as i1 from '@taiga-ui/cdk/services';
import { TuiDirectiveStylesService } from '@taiga-ui/cdk/services';

class TuiAutofilledStyleComponent {
}
TuiAutofilledStyleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiAutofilledStyleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TuiAutofilledStyleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiAutofilledStyleComponent, selector: "tui-autofilled-style", ngImport: i0, template: '', isInline: true, styles: [".tui-autofill input,input.tui-autofill{transition:box-shadow .01s}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiAutofilledStyleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-autofilled-style',
                    template: '',
                    styleUrls: ['./autofilled.style.less'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });

class TuiAutofilledDirective {
    constructor(directiveStyles) {
        this.autofilled = false;
        this.tuiAutofilledChange = new EventEmitter();
        directiveStyles.addComponent(TuiAutofilledStyleComponent);
    }
    transitionStartHandler({ propertyName, target }) {
        var _a;
        const matchedAutofill = propertyName.includes('box-shadow') && ((_a = target) === null || _a === void 0 ? void 0 : _a.matches('input'));
        if (matchedAutofill) {
            this.autofilled = !this.autofilled;
            this.tuiAutofilledChange.emit(this.autofilled);
        }
    }
}
TuiAutofilledDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiAutofilledDirective, deps: [{ token: TuiDirectiveStylesService }], target: i0.ɵɵFactoryTarget.Directive });
TuiAutofilledDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TuiAutofilledDirective, selector: "[tuiAutofilledChange]", outputs: { tuiAutofilledChange: "tuiAutofilledChange" }, host: { listeners: { "transitionstart": "transitionStartHandler($event)" }, properties: { "class._autofilled": "this.autofilled" }, classAttribute: "tui-autofill" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiAutofilledDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tuiAutofilledChange]',
                    host: { class: 'tui-autofill' },
                }]
        }], ctorParameters: function () { return [{ type: i1.TuiDirectiveStylesService, decorators: [{
                    type: Inject,
                    args: [TuiDirectiveStylesService]
                }] }]; }, propDecorators: { autofilled: [{
                type: HostBinding,
                args: ['class._autofilled']
            }], tuiAutofilledChange: [{
                type: Output
            }], transitionStartHandler: [{
                type: HostListener,
                args: ['transitionstart', ['$event']]
            }] } });

class TuiAutofilledModule {
}
TuiAutofilledModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiAutofilledModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiAutofilledModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiAutofilledModule, declarations: [TuiAutofilledDirective, TuiAutofilledStyleComponent], exports: [TuiAutofilledDirective] });
TuiAutofilledModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiAutofilledModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiAutofilledModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [TuiAutofilledDirective],
                    declarations: [TuiAutofilledDirective, TuiAutofilledStyleComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiAutofilledDirective, TuiAutofilledModule, TuiAutofilledStyleComponent };
